module.exports = __webpack_public_path__ + "img/consult_info2.19e9476f.png";